<template lang='pug'>
#modal-selecionar-cars-sobrepostos
    el-dialog.custom-dialog(
        :visible.sync='show',
        :close-on-click-modal='false',
        :close-on-press-escape='false',
        :destroy-on-close='true',
        :show-close='false',
        width='65%'
    )
        template(slot='title')
            div.dialog-header
                | {{ titleToTheModal() }}
        el-row
            el-col.menu-divider(:span="6")
                el-menu(v-model='activeItem', :default-active="activeItem" class='el-menu-vertical-demo', @select='handleSelect')
                    el-menu-item(v-if='dados.listaSigef && dados.listaSigef.length', index='incra')
                        span {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.parcelaIncraSigef') }}
                    el-menu-item(
                        v-for='(estado, index) in dados.carEstadoPaginado',
                        :name='estado.stateAbbreviation',
                        :index='estado.stateAbbreviation',
                        :key='index'
                    )
                        span CAR {{ estado.stateName }}
            el-col(:span="17")
                div(v-if="!activeItem")
                    el-empty.border-left(:description="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.nenhumItemSelecionado')")
                div(v-if='activeItem != "incra" && activeItem === activeItemData.stateAbbreviation && activeItemData', :key="'table1'")
                    p.view-title CAR {{ activeItemData.stateName }}
                    el-table.view-table(
                        ref='tabelaModalSelecionarCarsCpfOuCnpjRef',
                        :data='activeItemData.results',
                        style='width: 100%'
                    )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.car')",
                            width='382',
                            prop='codigo',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.areaHa')",
                            width='81',
                            prop='areaHa',
                            :formatter='formatAreaHaTableColumn',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.localidade')",
                            width='185',
                            prop='municipioUf',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.situacao')",
                            width='87',
                            prop='situacao',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.acao')",
                            align='center',
                            min-width='55'
                        )
                            template(slot-scope='props')
                                i.custom-cursor(
                                    @click='realizarDiagnostico(props.row, "car")',
                                    :title="!$route.path.toLowerCase().includes('territorio') ? $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.realizarDiagnosticoDoCar') : $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.inserirAreasPorNumeroCar')"
                                )
                                    img(src="@/assets/lyra-icons/svg/realizar-diagnostico.svg")
                    .c-pagination
                        el-pagination(
                            background,
                            :page-size='activeItemData.pageSize',
                            :current-page.sync='activeItemData.currentPage',
                            layout='prev, pager, next',
                            :total='activeItemData.totalResult',
                            @current-change='atualizarPagina'
                        )
                div(v-if='activeItem === "incra" && activeItemData', :key="'table2'")
                    p.view-title {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.parcelaIncraSigef') }}
                    el-table.view-table(
                        :data='activeItemData.results'
                        style='width: 100%'
                    )
                        el-table-column(type='expand')
                            template(slot-scope='props')
                                div(v-if='props.row.carsSobrepostos && props.row.carsSobrepostos.length > 0')
                                    el-table.custom-expanded-table(
                                        :data='props.row.carsSobrepostos',
                                        style='width: 100%',
                                    )
                                        el-table-column(
                                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.carsVinculados')",
                                            min-width='210',
                                            prop='codigo',
                                            align='left'
                                        )
                                        el-table-column(
                                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.areaHa')",
                                            min-width='100',
                                            prop='areaHa',
                                            :formatter='formatAreaHaTableColumn',
                                            align='left'
                                        )
                                        el-table-column(
                                            align='center',
                                            min-width='35'
                                        )
                                            template(slot-scope='props')
                                                i.custom-cursor(
                                                    @click='realizarDiagnostico(props.row, "car")',
                                                    :title="!$route.path.toLowerCase().includes('territorio') ? $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.realizarDiagnosticoDoCar') : $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.inserirAreasPorNumeroCar')"
                                                )
                                                    img(src="@/assets/lyra-icons/svg/realizar-diagnostico.svg")
                                el-alert.custom-expanded-table(
                                    v-else,
                                    :title="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.naoHaRegistrosCarSobreposto')",
                                    type='warning',
                                    :closable='false'
                                )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.numeroDaParcela')",
                            min-width='290',
                            prop='codigoParcela',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.carsVinculados')",
                            align='left',
                            min-width='160px'
                        )
                            template(slot-scope='{ row }')
                                | {{ row.carsSobrepostos ? row.carsSobrepostos.length : 0 }}
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.localidade')",
                            min-width='150',
                            :formatter='isEmpty'
                            prop='municipioUf',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.situacao')",
                            min-width='130',
                            :formatter='capitalizeFirstLetter',
                            prop='status',
                            align='left'
                        )
                        el-table-column(
                            :label="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.labels.acao')",
                            align='center',
                            min-width='90'
                        )
                            template(slot-scope='scope')
                                i.custom-cursor(
                                    @click='realizarDiagnostico(scope.row, "sigef")',
                                    :title="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.realizarDiagnosticoParcela')"
                                )
                                    img(src="@/assets/lyra-icons/svg/realizar-diagnostico.svg")
                    .c-pagination
                        el-pagination(
                            background,
                            :page-size='activeItemData.pageSize',
                            :current-page.sync='activeItemData.currentPage',
                            layout='prev, pager, next',
                            :total='activeItemData.totalResult',
                            @current-change='atualizarPaginaSigef'
                        )

        footer(slot='footer')
            BaseButton(@click='modalConfirmacaoVoltar = true', size='big')
                | {{ $t('mensagens.comuns.voltar') }}
            BaseButton.custom-buttom(
                v-if='tipo === "DIAGNOSTICO" && cpfCnpj !== "INCRA"',
                type='primary',
                size='big',
                @click='realizarDiagnosticoCpfCnpj'
            )
                img(src="@/assets/lyra-icons/svg/realizar-diagnostico.svg", :alt="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.realizarDiagnosticoDocumento')", class="custom-icon")
                | {{ $t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.realizarDiagnosticoDocumento') }}
    el-dialog(
        :visible.sync='modalConfirmacaoVoltar',
        :title="$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.aoVoltarTelaAnterior')",
        :destroy-on-close='true',
        :show-close='false',
        width='30%',
        append-to-body
    )
        footer(style='display: flex; justify-content: space-between')
            BaseButton(@click='modalConfirmacaoVoltar = false', size='mini')
                | {{ $t('mensagens.comuns.cancelar') }}
            BaseButton(
                type='primary',
                @click='fecharModalDeConfirmacaoVoltar',
                size='mini'
            )
                | {{ $t('mensagens.comuns.prosseguir') }}
    .cars-vinculados
</template>

<script>
import formatters from '@/utils/formatters';
import PaginaTamanho from '@/constants/PaginaTamanho';
import StatusCar from '@/constants/StatusCar';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalSelecionarCarsCpfCnpj',

    components: {
        BaseButton
    },

    props: {
        show: {
            type: Boolean,
            required: true
        },
        cpfCnpj: {
            type: String,
            required: false
        },
        tipo: {
            type: String,
            required: true
        },
        dados: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            modalConfirmacaoVoltar: false,
            dadosSelecionados: {},
            dadoSelecionado: null,
            btnSelecionarTodos: false,
            todosdadosSelecionados: false,
            activeItem: 'incra',
            activeItemData: null,
            collapseAtivo: null
        };
    },
    mounted() {
        this.setTableData();
    },

    watch: {
        show: function () {
            if (this.show) this.setTableData();
        }
    },

    methods: {
        setTableData() {
            if (this.dados != null) {
                if (this.dados.carEstadoPaginado != null && this.dados.carEstadoPaginado.length > 0) {
                    this.collapseAtivo = this.dados.collapseAtivo;
                    this.handleSelect(this.dados.carEstadoPaginado[0].stateAbbreviation);
                } else {
                    this.handleSelect('incra');
                }
            }

        },

        handleRowClick(row, column, event) {
            if (row.carsSobrepostos && row.carsSobrepostos.length > 0) {
                this.$refs.elTable.toggleRowExpansion(row);
            }
        },

        handleSelect(key) {
            this.activeItem = key;
            this.activeItemData = this.paginar(key);
        },

        paginar(key, page = 1) {
            const chaveIncra = 'incra';

            const tamanhoPagina = key === chaveIncra ? PaginaTamanho['GRID_CAR_INCRA'] : PaginaTamanho['GRID_CAR_ESTADO'];
            const primeiroRegistro = (page - 1) * tamanhoPagina;
            const ultimoRegistro = primeiroRegistro + tamanhoPagina;

            let nome = null;
            let registros = 0;
            let totalRegistros = [];

            if (key === chaveIncra) {
                nome = 'INCRA';
                registros = this.dados?.listaSigef;
                totalRegistros = this.dados?.listaSigef?.length;
            } else {
                const dadosImoveis = this.dados.carEstadoPaginado.find(
                    estado => estado.stateAbbreviation === key
                );

                nome = dadosImoveis.stateName;
                registros = dadosImoveis.results.map(
                    imovel => {
                        return {
                            ...imovel,
                            situacao: StatusCar[imovel.situacao]
                        };
                    }
                );
                totalRegistros = dadosImoveis.results.length;
            }

            return {
                stateAbbreviation: key,
                stateName: nome,
                pageSize: tamanhoPagina,
                currentPage: page,
                totalPages: Math.ceil(totalRegistros / tamanhoPagina),
                totalResult: totalRegistros || 0,
                results: registros ? registros.slice(primeiroRegistro, ultimoRegistro) : []
            };
        },

        formatAreaHaTableColumn(row, column, areaHa, index) {
            if (!areaHa) return;
            const area = String(areaHa);
            if (area.includes(',')) {
                let n = areaHa.split(',', 2);
                return n[0] + ',' + n[1].substr(2);
            }
            const options = {
                style: 'decimal',
                currency: 'BRL',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            };
            const formatNumber = new Intl.NumberFormat('pt-BR', options);
            return formatNumber.format(areaHa);
        },

        titleToTheModal() {
            if (this.cpfCnpj) {
                if (this.isCPF(this.cpfCnpj) || this.isCNPJ(this.cpfCnpj)) {
                    return `${this.$t('mensagens.diagnosticoSocioambiental.diagnosticoSocioambientalEmLote.documento')}: ${this.formatCpfCnpj(this.cpfCnpj)}`;
                } else if (this.isINCRA(this.cpfCnpj)) {
                    return `INCRA`;
                } else {
                    return this.cpfCnpj;
                }
            }
            return '';
        },

        formatCpfCnpj(cpfCnpj) {
            return formatters.numeralStringFormatToDocumento(formatters.removerPontuacaoDocumento(cpfCnpj));
        },

        isCPF(input) {
            const numbers = input.replace(/\D/g, '');
            return numbers.length === 11;
        },

        isCNPJ(input) {
            const numbers = input.replace(/\D/g, '');
            return numbers.length === 14;
        },

        isINCRA(input) {
            const numbers = input.replace(/\D/g, '');
            return numbers.length === 13;
        },

        isEmpty(row, column, data, index) {
            return formatters.isEmpty(data);
        },

        fecharModalDeConfirmacaoVoltar() {
            this.modalConfirmacaoVoltar = false;
            this.dadosSelecionados = {};
            this.$emit('voltar');
        },

        realizarDiagnostico(dadoSelecionado, tipo) {
            let path = this.$route.path.toLowerCase();
            let conjunto = tipo;

            if (path.includes('territorio')) {
                this.dadosSelecionados[conjunto] = this.dadosSelecionados[conjunto] || [];
                this.dadosSelecionados[conjunto].push(dadoSelecionado);
            }

            if (path.includes('diagnostico-socioambiental')) {
                this.dadosSelecionados = dadoSelecionado;
            }

            this.$emit('retornarDadosSelecionados', this.dadosSelecionados);
        },

        async atualizarPagina(pagina) {
            const estadoSelecionadoIndex =
                this.dados.carEstadoPaginado.findIndex(
                    s => s.stateAbbreviation === this.collapseAtivo
                );

            this.dadosSelecionados[this.collapseAtivo] = [];
            this.activeItemData = this.paginar(this.dados.carEstadoPaginado[estadoSelecionadoIndex].stateAbbreviation, pagina);
        },

        async atualizarPaginaSigef(pagina) {
            this.activeItemData = this.paginar('incra', pagina);
        },

        capitalizeFirstLetter(row, column, string, index) {
            if (!string || typeof string !== 'string') {
                return '';
            }
            return (
                string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
            );
        },

        buscarUrlImagem(nome) {
            return require(`@/assets/estados-icons/circle/png-200/${nome}.png`);
        },

        realizarDiagnosticoCpfCnpj() {
            this.$emit('retornarDadosSelecionados', this.cpfCnpj);
        }
    }
};
</script>

<style lang='scss' scoped>
#modal-selecionar-cars-sobrepostos {
    .custom-cursor {
        cursor: pointer;
    }

    .custom-expanded-table {
        margin-top: -20px;
    }

    .custom-icon {
        margin-right: 9px;
        vertical-align: middle;
        filter: brightness(0) invert(1);
    }

    .custom-buttom:hover .custom-icon {
        filter: none;
    }

    .lyra-icon {
        cursor: pointer;
    }

    .menu-description {
        font-weight: 400;
        font-size: 16px;
    }

    .dialog-header {
        background-color: #e9e9e9;
        color: #00413c;
        padding: 15px;
        margin: -20px -20px 20px -20px;
        font-size: 18px;
        font-weight: 600;
        border-radius: 5px, 5px, 0px, 0px;
        box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.2);
    }

    .custom-dialog {
        border-radius: 5px;
    }

    footer {
        display: flex;
        justify-content: space-between;
    }

    .c-pagination {
        text-align: center;
        margin-top: 30px;
    }

    .el-menu-vertical-demo .el-menu-item.is-active {
        color: #359138;
        border-right: 2px solid #359138;
    }

    .el-menu-vertical-demo span {
        font-size: 14px;
        font-weight: 500;
    }

    .view-title {
        margin-left: 15px;
        font-size: 16px;
        font-weight: 500;
    }

    .view-table {
        margin-left: 15px;
    }

    .border-left {
        border-left: 1px solid #359138;
    }

    .custom-divider {
        margin-bottom: 0px;
    }

    .el-table {
        .el-table__expand-icon {
            height: 24px;
            width: 24px;
            margin-bottom: 10px;
        }

        .el-table__expand-icon>.el-icon {
            color: #3b3b3b;
            font-weight: 700;
            font-size: 16px;
        }

        thead {
            color: var(--primary);
            font-size: 16px;
            font-weight: 500;
            line-height: 18.75px;
        }

        .el-descriptions-row {
            .el-descriptions-item__label {
                color: var(--primary);
                font-weight: 500;
                font-size: 16px;
                line-height: 18.75px;
            }
        }

        .el-descriptions-item__label.has-colon::after {
            content: '';
        }
    }
}
</style>

<style lang='scss'>
label {
    margin: 0 !important;
}

.el-dialog {
    margin-top: 55px !important;
}

.el-dialog__header {
    padding-bottom: 0px !important;
}

.el-dialog__body {
    padding: 10px 20px !important;
}
</style>
